'use es6';

import classNames from 'classnames';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ResultCtaBanner = ({
  children,
  use
}) => {
  const classes = classNames('cta-icon', {
    'trophy': 'icon-trophy',
    'mobile': 'icon-mobile',
    'lock': 'icon-locked',
    'search': 'icon-search'
  }[use]);
  return /*#__PURE__*/_jsx("div", {
    className: "result-cta-container",
    children: /*#__PURE__*/_jsxs("div", {
      className: "result-cta-banner",
      children: [/*#__PURE__*/_jsx("div", {
        className: classes
      }), /*#__PURE__*/_jsx("div", {
        className: "cta-info",
        children: children
      })]
    })
  });
};
export default ResultCtaBanner;